function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import trackRubriqEvent from 'rubriq/helpers/trackRubriqEvent';
import featureEnabled from 'shared/helper/feature';
import IdentifyPage from 'researcher/application/components/IdentifyPage';
import { T, useTranslate } from 'shared/helper/translate';
import { price } from 'researcher/helpers/price';
import { getChinaLocalization } from 'shared/account/reducer';
import { recordFreeTrialPurchaseInitiated, recordPurchaseComplete } from 'researcher/helpers/gtm';
import { getAvailableNewPlans, getAvailablePlans, getPaddlePrices, isPaddlePricesLoading, getCurrencyIsoCode } from '../reducer';
import useNavigate from '../hooks/useNavigate';
import { PADDLE_PLAN_TYPES, RUBRIQ_PLAN_NAMES_MAP } from '../constants';
import { flagPlanUpdate } from '../actions';
import ModalError from '../components/ModalError';
import PaddleOverlayButton from './PaddleOverlayButton';
import PaddleBillingOverlayButton from './PaddleBillingOverlayButton';
var RubriqROWPurchaseSummary = function RubriqROWPurchaseSummary(_ref) {
  var _selectedPlan$name;
  var freeTrial = _ref.freeTrial,
    snTrial = _ref.snTrial;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var _useSelector = useSelector(function (state) {
      return state;
    }),
    user = _useSelector.user;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    selectedPlan = _useState2[0],
    setSelectedPlan = _useState2[1];
  var chinaLocalization = useSelector(getChinaLocalization);
  var enablePaddleCountryPrice = true;
  var paddlePrices = useSelector(getPaddlePrices);
  var currencyIsoCode = useSelector(getCurrencyIsoCode);
  var loadingPaddlePrices = useSelector(isPaddlePricesLoading);
  var paddleBillingForNewSubscription = featureEnabled('curie_use_paddle_billing_for_new_subscriptions');
  var newRowPlans = featureEnabled('rubriq_show_repriced_and_renamed_plans_for_row');
  var paddleBillingForChina = featureEnabled('rubriq_china_also_uses_paddle');
  var newPlans = useSelector(getAvailableNewPlans);
  var regularPlans = useSelector(getAvailablePlans);
  var availableSubscriptionPlans = newRowPlans ? newPlans : regularPlans;
  var needsCurrencyConversion = !chinaLocalization;
  var rawPlanName = (_selectedPlan$name = selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.name) !== null && _selectedPlan$name !== void 0 ? _selectedPlan$name : null;
  var formattedPlanName = RUBRIQ_PLAN_NAMES_MAP[rawPlanName] || rawPlanName || '';
  var isTrial = (premium === null || premium === void 0 ? void 0 : premium.status) === 'trialing';
  if (isTrial && formattedPlanName) {
    formattedPlanName = "".concat(formattedPlanName, " (Trial)");
  }
  useEffect(function () {
    trackRubriqEvent('Checkout Started', {
      user_email: (user === null || user === void 0 ? void 0 : user.email) || null,
      device: navigator.userAgent,
      page: window.location.pathname,
      trial_plan_used: trialPlanUsed || false,
      planName: "".concat(formattedPlanName, " (Trial)") || null,
      price: (selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.price) || 0,
      billing_cycle: (selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.billingInterval) || null,
      email: user === null || user === void 0 ? void 0 : user.email,
      user_identity: user.identity
    });
  }, []);
  var getSubscriptionPlansByType = function getSubscriptionPlansByType() {
    if (snTrial) {
      return (availableSubscriptionPlans === null || availableSubscriptionPlans === void 0 ? void 0 : availableSubscriptionPlans.snTrial30Days) || [];
    }
    if (freeTrial) {
      if (newRowPlans) {
        return (availableSubscriptionPlans === null || availableSubscriptionPlans === void 0 ? void 0 : availableSubscriptionPlans.editing) || [];
      }
      return (availableSubscriptionPlans === null || availableSubscriptionPlans === void 0 ? void 0 : availableSubscriptionPlans.trial) || [];
    }
    if (newRowPlans) {
      return (availableSubscriptionPlans === null || availableSubscriptionPlans === void 0 ? void 0 : availableSubscriptionPlans.premiumWithTranslation) || [];
    }
    return (availableSubscriptionPlans === null || availableSubscriptionPlans === void 0 ? void 0 : availableSubscriptionPlans.premium) || [];
  };
  var availablePlans = getSubscriptionPlansByType();
  var _useSelector2 = useSelector(function (state) {
      return state;
    }),
    curie = _useSelector2.curie;
  var premium = curie.plans.premium;
  var trialPlanUsed = curie === null || curie === void 0 ? void 0 : curie.alreadyTriedUser;
  var isPlanActive = (premium === null || premium === void 0 ? void 0 : premium.status) === 'active' || (premium === null || premium === void 0 ? void 0 : premium.status) === 'cancelled';
  var getDisplayPrice = function getDisplayPrice(plan, fallbackPrice) {
    if (!enablePaddleCountryPrice) {
      return price(user.currency, fallbackPrice, true, needsCurrencyConversion);
    }
    if (loadingPaddlePrices) {
      return price(user.currency, fallbackPrice, true, needsCurrencyConversion);
    }
    var paddlePrice = paddlePrices[plan === null || plan === void 0 ? void 0 : plan.paddlePlanId];
    if (paddlePrice) {
      return "".concat(paddlePrice.currencySymbol).concat(paddlePrice.amount.toFixed(2));
    }
    return price(user.currency, fallbackPrice, true, needsCurrencyConversion);
  };
  var getPriceValue = function getPriceValue(plan, fallbackPrice) {
    if (!enablePaddleCountryPrice || loadingPaddlePrices) {
      return fallbackPrice;
    }
    var paddlePrice = paddlePrices[plan === null || plan === void 0 ? void 0 : plan.paddlePlanId];
    if (paddlePrice) {
      return paddlePrice.amount;
    }
    return fallbackPrice;
  };
  var getMonthlyPriceDisplay = function getMonthlyPriceDisplay(plan, isYearly) {
    if (!enablePaddleCountryPrice || loadingPaddlePrices) {
      var _basePrice = isYearly ? plan.price / 12 : plan.price;
      return price(user.currency, _basePrice, true, needsCurrencyConversion);
    }
    var paddlePrice = paddlePrices[plan === null || plan === void 0 ? void 0 : plan.paddlePlanId];
    if (paddlePrice) {
      var monthlyAmount = isYearly ? paddlePrice.amount / 12 : paddlePrice.amount;
      return "".concat(paddlePrice.currencySymbol).concat(monthlyAmount.toFixed(2));
    }
    var basePrice = isYearly ? plan.price / 12 : plan.price;
    return price(user.currency, basePrice, true, needsCurrencyConversion);
  };
  var getZeroPriceDisplay = function getZeroPriceDisplay(plan) {
    if (enablePaddleCountryPrice && !loadingPaddlePrices) {
      var paddlePrice = paddlePrices[plan === null || plan === void 0 ? void 0 : plan.paddlePlanId];
      if (paddlePrice) {
        return "".concat(paddlePrice.currencySymbol, "0.00");
      }
    }
    return price(user.currency, 0, true, needsCurrencyConversion);
  };
  if (chinaLocalization && !paddleBillingForChina) {
    return /*#__PURE__*/React.createElement(Navigate, {
      to: "/rubriq/plan/subscribe",
      replace: true
    });
  }
  if (isPlanActive) {
    return /*#__PURE__*/React.createElement(Navigate, {
      to: "/rubriq",
      replace: true
    });
  }
  var buildBillingCycleText = function buildBillingCycleText() {
    var yearlyPlan = {};
    var monthlyPlan = {};
    availablePlans.forEach(function (plan) {
      if (plan.billingInterval === PADDLE_PLAN_TYPES.YEARLY) {
        yearlyPlan = plan;
      } else if (plan.billingInterval === PADDLE_PLAN_TYPES.MONTHLY) {
        monthlyPlan = plan;
      }
    });
    var yearlyPrice = getPriceValue(yearlyPlan, yearlyPlan.price);
    var monthlyPrice = getPriceValue(monthlyPlan, monthlyPlan.price);
    var annualPercentSavings = "".concat(Math.floor(100 * ((monthlyPrice - yearlyPrice / 12) / monthlyPrice)), "%");
    return [annualPercentSavings];
  };
  if ((availablePlans === null || availablePlans === void 0 ? void 0 : availablePlans.length) >= 1) {
    if (selectedPlan === null) {
      setSelectedPlan(availablePlans[0]);
    }
  }
  var _buildBillingCycleTex = buildBillingCycleText(),
    _buildBillingCycleTex2 = _slicedToArray(_buildBillingCycleTex, 1),
    annualPercentSavings = _buildBillingCycleTex2[0];
  var dispatch = useDispatch();
  var navigate = useNavigate();

  // const onPaddleCheckoutClose = async (result) => {
  //     if (result) {
  //         if (trialPeriod > 0) {
  //             const productName = selectedPlan?.name;
  //             const price = selectedPlan?.price;

  //             recordFreeTrialPurchaseInitiated({
  //                 buttonText: 'start_free_trial_payment_btn',
  //                 productName,
  //                 finalAmount: price,
  //             });
  //         }

  //         const response = await dispatch(flagPlanUpdate());

  //         if (response?.status?.paddlePending) {
  //             navigate('/rubriq');
  //         } else {
  //             window.location.href = '/rubriq';
  //         }
  //         window.location.reload();
  //     }
  // };

  var onPaddleCheckoutClose = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(result) {
      var _response$status, _productName, _price, productName, planTermText, response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!result) {
              _context.next = 11;
              break;
            }
            if (trialPeriod > 0) {
              _productName = selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.name;
              _price = selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.price;
              recordFreeTrialPurchaseInitiated({
                buttonText: 'start_free_trial_payment_btn',
                productName: _productName,
                finalAmount: getPriceValue(selectedPlan, _price),
                currency: currencyIsoCode
              });
            }
            productName = 'Rubriq Premium with Translation';
            if (snTrial) {
              productName = 'SN 30-Day Trial';
            } else if (freeTrial) {
              productName = 'Rubriq Premium';
            }
            planTermText = (selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.billingInterval) === PADDLE_PLAN_TYPES.YEARLY ? 'Yearly' : 'Monthly';
            recordPurchaseComplete({
              transactionId: "paddle_".concat(selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.paddlePlanId),
              orderId: "paddle_".concat(selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.paddlePlanId),
              revenue: getPriceValue(selectedPlan, selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.price),
              currency: currencyIsoCode,
              productName: productName,
              planTerm: planTermText,
              paymentMode: 'paddle'
            });
            _context.next = 8;
            return dispatch(flagPlanUpdate());
          case 8:
            response = _context.sent;
            if (response !== null && response !== void 0 && (_response$status = response.status) !== null && _response$status !== void 0 && _response$status.paddlePending) {
              navigate('/rubriq');
            } else {
              window.location.href = '/rubriq';
            }
            window.location.reload();
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function onPaddleCheckoutClose(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var timePeriod = t((selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.billingInterval) === PADDLE_PLAN_TYPES.YEARLY ? 'rubriq.annually' : 'curie.month');
  var planPeriod = (selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.billingInterval) === PADDLE_PLAN_TYPES.YEARLY ? 'year' : 'month';
  var priceDetails = {
    price: getDisplayPrice(selectedPlan, selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.price),
    timePeriod: timePeriod
  };
  var trialPeriod = selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.trialDays;
  var getPageTitle = function getPageTitle() {
    if (snTrial) return '30-Day Free Trial';
    if (freeTrial) return 'Free Trial';
    return 'Purchase Rubriq Premium';
  };
  var today = new Date();
  var sevenDaysLater = new Date();
  sevenDaysLater.setDate(today.getDate() + trialPeriod);
  var renewalDate = new Date();
  if ((selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.billingInterval) === PADDLE_PLAN_TYPES.YEARLY) {
    renewalDate.setFullYear(today.getFullYear() + 1);
  } else {
    renewalDate.setMonth(today.getMonth() + 1);
  }
  var nextRenewalDate = renewalDate;
  var formatDate = function formatDate(date) {
    var day = String(date.getDate()).padStart(2, '0');
    var month = String(date.getMonth() + 1).padStart(2, '0');
    var year = date.getFullYear();
    return "".concat(day, "/").concat(month, "/").concat(year);
  };
  var getProductName = function getProductName() {
    if (snTrial) return /*#__PURE__*/React.createElement(T, {
      source: "curie.curie-sn-users-30days-free-trial-plan"
    });
    if (freeTrial) return /*#__PURE__*/React.createElement(T, {
      source: "curie.curie-premium"
    });
    return /*#__PURE__*/React.createElement(T, {
      source: "rubriq.rubriq-premium-with-translation"
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IdentifyPage, {
    title: getPageTitle()
  }), /*#__PURE__*/React.createElement("div", {
    className: "w-75 mx-auto col-12 bg-white rubriq-specific-font g-padding"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", {
    className: "h3 fw-semibold text-dark mb-2"
  }, /*#__PURE__*/React.createElement(T, {
    source: "rubriq.purchase-summary-header"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "row rubriq-purchase-summary-row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-lg-8 col-md-7 border-end"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "h5 fw-semibold mb-0 text-dark"
  }, trialPlanUsed ? /*#__PURE__*/React.createElement(T, {
    source: "rubriq.trial-price",
    params: {
      price: getDisplayPrice(selectedPlan, selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.price)
    }
  }) : /*#__PURE__*/React.createElement(T, {
    source: "rubriq.trial-price",
    params: {
      trialPeriod: trialPeriod,
      price: getZeroPriceDisplay(selectedPlan)
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column gap-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "p-0 m-0 mt-3 rubriq-plan-feature-list"
  }, trialPlanUsed ? /*#__PURE__*/React.createElement(T.md, {
    source: "rubriq.purchase-summary-feature-list-no-trial",
    params: {
      planPeriod: planPeriod
    }
  }) : /*#__PURE__*/React.createElement(T.md, {
    source: "rubriq.purchase-summary-feature-list",
    params: {
      trialPeriod: trialPeriod
    }
  })))), /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column gap-3"
  }, availablePlans.map(function (plan) {
    var isSelected = (selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.paddlePlanId) === plan.paddlePlanId;
    var cardClass = isSelected ? 'border-success rubriq-selected' : 'rubriq-un-selected';
    var isYearly = plan.billingInterval === PADDLE_PLAN_TYPES.YEARLY;
    var planPrice = getPriceValue(plan, plan.price);
    var monthlyPrice = isYearly ? planPrice / 12 : planPrice;
    var savings = isYearly ? annualPercentSavings : null;
    return /*#__PURE__*/React.createElement("div", {
      key: plan.paddlePlanId,
      className: "card border-2 ".concat(cardClass, " position-relative bg-transparent"),
      style: {
        cursor: 'pointer',
        transition: 'all 0.2s'
      },
      onClick: function onClick() {
        setSelectedPlan(plan);
        trackRubriqEvent('Duration Selected', {
          user_email: (user === null || user === void 0 ? void 0 : user.email) || null,
          device: navigator.userAgent,
          selected_plan: plan.name,
          billing_cycle: plan.billingInterval,
          price: plan.price,
          email: user === null || user === void 0 ? void 0 : user.email,
          user_identity: user.identity
        });
      },
      role: "button",
      tabIndex: 0,
      onKeyDown: function onKeyDown(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          setSelectedPlan(plan);
        }
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "card-body p-3 d-flex flex-column justify-content-between h-100"
    }, isYearly && /*#__PURE__*/React.createElement("div", {
      className: "mb-2"
    }, /*#__PURE__*/React.createElement("span", {
      className: "badge rubriq-badge px-3 py-2 rounded-pill"
    }, /*#__PURE__*/React.createElement(T, {
      source: "rubriq.most-popular"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "d-flex justify-content-between align-items-center flex-grow-1 flex-column"
    }, /*#__PURE__*/React.createElement("div", {
      className: "d-flex align-items-center justify-content-between w-100 mb-2"
    }, /*#__PURE__*/React.createElement("div", {
      className: "d-flex align-items-center gap-3"
    }, /*#__PURE__*/React.createElement("div", {
      className: "rounded-circle border border-2 d-flex align-items-center justify-content-center ".concat(isSelected ? 'border-success rubriq-bg' : 'border-secondary'),
      style: {
        width: '20px',
        height: '20px'
      }
    }, isSelected && /*#__PURE__*/React.createElement("div", {
      className: "bg-white rounded-circle",
      style: {
        width: '8px',
        height: '8px'
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "fw-medium text-dark"
    }, /*#__PURE__*/React.createElement(T, {
      source: isYearly ? 'rubriq.annually' : 'curie.monthly'
    }))), /*#__PURE__*/React.createElement("div", {
      className: "h5 fw-bold text-dark mb-0"
    }, getMonthlyPriceDisplay(plan, isYearly), " /", /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(T, {
      source: "curie.month"
    })))), /*#__PURE__*/React.createElement("div", {
      className: "d-flex justify-content-between align-items-center w-100 small text-muted"
    }, trialPlanUsed ? /*#__PURE__*/React.createElement("div", null, getDisplayPrice(plan, plan.price), ' ', /*#__PURE__*/React.createElement(T, {
      source: "rubriq.payment-today"
    })) : /*#__PURE__*/React.createElement("div", null, getZeroPriceDisplay(plan), ' ', /*#__PURE__*/React.createElement(T, {
      source: "rubriq.payment-today"
    })), savings && /*#__PURE__*/React.createElement("div", {
      className: "d-flex align-items-center rubriq-discount-badge gap-1"
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: "fa-solid fa-tag"
    }), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(T, {
      source: "rubriq.save"
    }), " ", savings))))));
  })), /*#__PURE__*/React.createElement("div", {
    className: "mt-3 text-end"
  }, (selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.paddlePlanId) && (paddleBillingForNewSubscription ? /*#__PURE__*/React.createElement(PaddleBillingOverlayButton, {
    paddlePlanId: selectedPlan.paddlePlanId,
    onClose: onPaddleCheckoutClose,
    className: "btn rubriq-paddle-button",
    style: {
      fontSize: '16px'
    }
  }, /*#__PURE__*/React.createElement(T, {
    source: "rubriq.continue-to-payment"
  })) : /*#__PURE__*/React.createElement(PaddleOverlayButton, {
    paddlePlanId: selectedPlan.paddlePlanId,
    onClose: onPaddleCheckoutClose,
    className: "btn btn-success w-100 py-3 fw-medium",
    style: {
      fontSize: '16px'
    }
  }, /*#__PURE__*/React.createElement(T, {
    source: "rubriq.continue-to-payment"
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card bg-transparent border-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-body p-4"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "h5 fw-medium text-dark mb-4"
  }, /*#__PURE__*/React.createElement(T, {
    source: "rubriq.your-order-summary"
  })), /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column gap-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fw-semibold text-dark"
  }, getProductName()), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: "fw-semibold text-dark"
  }, /*#__PURE__*/React.createElement(T, {
    source: "rubriq.billed"
  }), ' ', /*#__PURE__*/React.createElement(T, {
    source: (selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.billingInterval) === PADDLE_PLAN_TYPES.YEARLY ? 'rubriq.annually' : 'curie.monthly'
  })), ' ', (selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.billingInterval) === PADDLE_PLAN_TYPES.YEARLY && /*#__PURE__*/React.createElement("span", null, "(", /*#__PURE__*/React.createElement(T, {
    source: "rubriq.save"
  }), " ", annualPercentSavings, ")")), /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-start gap-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "rounded-circle d-flex align-items-center justify-content-center flex-shrink-0",
    style: {
      width: '24px',
      height: '24px',
      marginTop: '2px',
      backgroundColor: '#D3A834'
    }
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "fw-medium text-dark"
  }, /*#__PURE__*/React.createElement(T, {
    source: "rubriq.today"
  }), " ", formatDate(today)), trialPlanUsed ? /*#__PURE__*/React.createElement("div", {
    className: "small text-muted"
  }, priceDetails.price, ' ', /*#__PURE__*/React.createElement(T, {
    source: (selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.billingInterval) === PADDLE_PLAN_TYPES.YEARLY ? 'rubriq.billed-annually' : 'rubriq.billed-monthly'
  })) : /*#__PURE__*/React.createElement("div", {
    className: "small text-muted"
  }, /*#__PURE__*/React.createElement(T, {
    source: "rubriq.trial-days-at-price",
    params: {
      trialPeriod: trialPeriod,
      price: getZeroPriceDisplay(selectedPlan)
    }
  })))), /*#__PURE__*/React.createElement("div", {
    className: "position-relative",
    style: {
      height: '70px',
      marginLeft: '12px'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "position-absolute top-0 start-0",
    style: {
      height: '100%',
      width: '1px',
      borderLeft: '2px dashed #7F7F7F'
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-start gap-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "rounded-circle d-flex align-items-center justify-content-center flex-shrink-0",
    style: {
      width: '24px',
      height: '24px',
      marginTop: '2px',
      backgroundColor: '#D9D9D9'
    }
  }), trialPlanUsed ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "fw-medium text-dark"
  }, /*#__PURE__*/React.createElement(T, {
    source: "rubriq.auto-renew"
  }), " ", formatDate(nextRenewalDate)), /*#__PURE__*/React.createElement("div", {
    className: "small text-muted"
  }, /*#__PURE__*/React.createElement(T, {
    source: "rubriq.cancel-anytime"
  }))) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "fw-medium text-dark"
  }, /*#__PURE__*/React.createElement(T, {
    source: "rubriq.starting"
  }), " ", formatDate(sevenDaysLater)), /*#__PURE__*/React.createElement("div", {
    className: "small text-muted"
  }, priceDetails.price, ' ', /*#__PURE__*/React.createElement(T, {
    source: (selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.billingInterval) === PADDLE_PLAN_TYPES.YEARLY ? 'rubriq.billed-annually' : 'rubriq.billed-monthly'
  })))))))))), /*#__PURE__*/React.createElement(ModalError, null));
};
export default RubriqROWPurchaseSummary;